import { PROFESSIONAL } from 'self-service-api/constants/ProductLevels';
import { PopularFeaturesMap } from '../constants/PopularFeaturesMap';
export const getPopularFeaturesByProductLine = ({
  featuresByProductLine,
  productLine,
  upgradePointApiName,
  upgradePointFeature,
  productLevel
}) => {
  if (!upgradePointFeature || !Object.keys(featuresByProductLine).length || productLevel !== PROFESSIONAL) return [];
  const features = featuresByProductLine[productLine] || [];
  const popularFeatures = PopularFeaturesMap[upgradePointApiName];
  // Remove the current upgrade page feature from the popular features list
  const popularFeatureKeys = Object.keys(popularFeatures);
  const currentFeatureKey = Object.keys(popularFeatures).find(key => popularFeatures[key].includes(upgradePointFeature));
  if (currentFeatureKey !== undefined) delete popularFeatures[currentFeatureKey];
  // Sort by popularity (ordered defined in PopularFeaturesMap) and return only the top 3
  return features.filter(feature => feature.shortName in popularFeatures).sort((a, b) => popularFeatureKeys.indexOf(a.shortName) - popularFeatureKeys.indexOf(b.shortName)).slice(0, 3);
};
export const pinKeyFeatures = (features, identifier, PinnedFeaturesConfig) => {
  const pinnedFeatures = PinnedFeaturesConfig[identifier];
  if (!pinnedFeatures) return features;
  const pinnedFeaturesSet = new Set(pinnedFeatures);
  const pinned = [];
  const remaining = [];
  features.forEach(feature => {
    if (pinnedFeaturesSet.has(feature.shortName)) {
      pinned.push(feature);
    } else {
      remaining.push(feature);
    }
  });
  pinned.sort((a, b) => pinnedFeatures.indexOf(a.shortName) - pinnedFeatures.indexOf(b.shortName));
  return [...pinned, ...remaining];
};